// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import _ from 'lodash';

// Setting worker path to worker bundle.
// https://github.com/mozilla/pdf.js/blob/master/examples/webpack/main.js#L11
// https://github.com/mozilla/pdf.js/blob/master/examples/webpack/webpack.config.js#L8

require('pdfjs-dist/build/pdf');
require('pdfjs-dist/web/pdf_viewer'); // Only if you need `PDFJS.PDFViewer`

PDFJS.workerSrc = 'pdf.worker.bundle.js';

// -- views
import SvgIcon from '../SvgIcon';

export default class PdfView extends Component {

  static propTypes = {
    file: PropTypes.object,

    content: PropTypes.string,

    page: PropTypes.number,

    httpHeaders: PropTypes.object,

    scale: PropTypes.number,
    loading: PropTypes.object,

    onClick: PropTypes.func.isRequired,

    onDocumentComplete: PropTypes.func.isRequired,

    onPageCompleted: PropTypes.func.isRequired
  };

  static defaultProps = {
    page: 1,

    scale: 1.0,

    loading: null,

    httpHeaders: null
  };

  state = {
    pageInfo: null,

    pdf: null
  };

  componentDidMount() {
    this.loadPDFDocument(this.props);
    this.renderPdf();
  }

  componentWillReceiveProps(newProps) {
    if ((newProps.file && newProps.file !== this.props.file) || (newProps.content && newProps.content !== this.props.content)) {
      this.loadPDFDocument(newProps);
    }
    if (!!this.state.pdf && !!newProps.page && newProps.page !== this.props.page) {
      this.setState({
        pageInfo: null
      });
      this.state.pdf.getPage(newProps.page).then(this.onPageCompleted);
    }
  }

  // -- pdf loading

  onDocumentComplete = (pdf) => {
//    if (!this.isMounted()) {
// return;
//  }
    this.setState({
      pdf
    });

    this.props.onDocumentComplete(pdf.numPages);

    pdf.getPage(this.props.page).then(this.onPageCompleted);
  };

  onPageCompleted = (pageInfo) => {

    this.setState({
      pageInfo
    });

    this.renderPdf();

    this.props.onPageCompleted(pageInfo.pageIndex + 1);
  };

  loadByteArray(byteArray) {
    PDFJS.getDocument(byteArray).then(this.onDocumentComplete);
  }

  loadPDFDocument(props) {
    if (!!props.file) {
      if (_.isString(props.file)) {
        if (!_.isNull(this.props.httpHeaders)) {
          // see https://groups.google.com/forum/#!topic/mozilla.dev.pdf-js/iDUqbjMRcGc
          const docInitParams = {
            url: props.file,
            httpHeaders: this.props.httpHeaders
          };
          return PDFJS.getDocument(docInitParams).then(this.onDocumentComplete);
        }

        return PDFJS.getDocument(props.file).then(this.onDocumentComplete);
      }
      // Is a File object
      const reader = new FileReader();
      reader.onload = () => {
        const content = new Uint8Array(reader.result);
        this.loadByteArray(content);
      };
      reader.readAsArrayBuffer(props.file);
    } else if (!!props.content) {
      const bytes = window.atob(props.content);
      const byteLength = bytes.length;
      const byteArray = new Uint8Array(new ArrayBuffer(byteLength));
      for (let index = 0; index < byteLength; index++) {
        byteArray[index] = bytes.charCodeAt(index);
      }
      this.loadByteArray(byteArray);
    } else {
      console.error('pdfViewer works with a file(URL) or (base64)content. At least one needs to be provided!');
    }
  }

  renderCanvas() {
    return (
      <canvas
        className="pdf_canvas"
        ref="pdfCanvas"
        onClick={this.props.onClick}
      />
    );
  }

  renderPdf() {
    const pageInfo = this.state.pageInfo;

    if (!_.isNull(pageInfo)) {

      // see http://mozilla.github.io/pdf.js/examples/
      const canvas = ReactDOM.findDOMNode(this.refs.pdfCanvas);
      const context = canvas.getContext('2d');
      const scale = this.props.scale;
      const viewport = pageInfo.getViewport(scale);

      canvas.height = viewport.height;
      canvas.width = viewport.width;

      const renderContext = {
        canvasContext: context,
        viewport
      };

      pageInfo.render(renderContext);
    }
  }

  renderLoading() {
    if (_.isNull(this.props.loading)) {
      return (
        <div className="pdf_canvas_loading">
          <SvgIcon
            icon={SvgIcon.LOADING_BAR}
          />
        </div>
      );
    }
    return (this.props.loading);
  }

  render() {
    if (!_.isNull(this.state.pageInfo)) {
      return this.renderCanvas();
    }

    return this.renderLoading();
  }

}



// WEBPACK FOOTER //
// ./sdk/scripts/components/pdfViewer/PdfView.js